<template>

  <div>
    <div id="scatter-legend" class="scatterplot-legend"></div>
    <div id="hover-description"></div>
    <div id="scatter-chart"></div>
  </div>

</template>

<script>

	import * as d3 from 'd3';
	import scatterSet from '@/charts/scatterplot';
	import scrollTo from '@/utils/scrollTo'

	//functions used to prepare data and the opts dictionary for the scatter set
	const prep_data = (data, datasegment) => {
		let flat_data = [];
		data.forEach(g => {
			let merged_data = g.data.map((d, i) => {
				return {...d, group: g.groupName, name: g.name, slug: g.id[2]}
			})
			flat_data = [...flat_data, ...merged_data]
		})

		if (datasegment) {
			flat_data = flat_data.filter(d => d.group.toLowerCase() === datasegment.toLowerCase())
		}

		return flat_data
	}

	//consume the output from prep_data above.
	const deduce_fields = function (flat_data) {

		const unique_fields = new Set([...flat_data.map(d => d.label)])
		const scatter_array = [];

		unique_fields.forEach(d => {
			scatter_array.push({focusvar: d})
		})
		return scatter_array;

	}


	export default {
		name: "ScatterSet",
		props: ["data", "datasegment", "updateIncrement"],
		data() {
			return {
				scatterSet: null,
			}
		},

		watch: {
			//  WE INCREMENT THIS PROP AS A GUARANTEED WAY OF FIRING THE WATCH FUNCTION,
			// TO AVOID BUGS IN REACTIVITY WITH DEEPLY NESTED DICTIONARIES
			updateIncrement: function () {
				if (this.scatterSet) {
					this.scatterSet.update(this.opts)
				}
			}

		},
		computed: {
			opts: function () {

				const cdata = prep_data(this.data, this.datasegment);


        console.log('DATA', cdata);
				return {
					data: cdata,
					datasegment: this.datasegment,
					groupvar: "name",
					bindLegendTo: '#scatter-legend',
					bindTo: '#scatter-chart',
					bindDescriptionTo: '#hover-description',
					legenditemlink: true,
					legendlinkfactory: function (slug) {
						return '/dashboard/' + slug + '/'
					},
					scatterplots: deduce_fields(cdata),
          updateIncrement: this.updateIncrement, // I have to increment update every single time i get new data. Reactivity will not consistenly fire
                  ///deep down in the array of data. Therefore, I simply increment a toggle prop to trigger the watch() funciton
				}
			}

		},
		mounted() {

			this.scatterSet = new scatterSet(this.opts);

			//handle the scroll animation
			const legendElem = document.getElementById('scatter-legend')



      setTimeout(() => { scrollTo(legendElem, 200, 1000) }, 3000);
      setTimeout(() => { scrollTo(legendElem, 0, 1000) }, 4000);


      // const legendAnim = new Promise((resolve) => {
      // 	setTimeout(() => {
      // 		scrollTo(legendElem, 600, 1000); resolve(true);},
      //       3000);
      //
      // }).then(() => {
      // 	scrollTo(legendElem, 0, 1000);
      // })
      //



		}
	}

</script>

<style lang="less"> //not scoped. Need to reach d3 generated elements. Careful with your namespace!

  @import "../../assets/less/palette";


  h3.chart-title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: -2.5em;
      text-align: left!important;
      margin-left: 5%;
  }



   .scatterplot {
      max-width: 900px;
     margin: auto;
    }

    .scatterplot-legend {
      display: flex;
      -webkit-display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;
      font-size: 15px;
      margin: 18px auto;
      max-height: 97px;
      min-height: 10px;
      overflow-x: hidden;
      overflow-y: scroll;
      padding: 9px;
      padding-left: 5%; // 5% == 25/500, which is the g group offset of the axis in the svg
      -ms-overflow-style: none;
      max-width: 900px;
      margin-right: 18px;
      border-right: 1px solid @primary;

    }

    .scatterplot-legend .filterbutton {
      display: inline-block;
      font-size: 8px;
      margin: 0 0 0 8px;
      padding: 0 2px;
      color: #595959;
      border: 1px solid #595959;
      background-color: #e2e2e2;
      border-radius: 3px;

    }

    .scatterplot-legend-buttons {
      display: flex;
      -webkit-display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      height: 48px;
      -ms-overflow-style: none;
      max-width: 1000px;
      margin: 4px 20px;
    }

    .scatterplot-legend::-webkit-scrollbar {
      display: none;
    }

    .scatterplot-top-button-wrapper {
      display: flex;
      -webkit-display: flex;
      flex-wrap: no-wrap;
      justify-content: center;
      font-size: 15px;
      margin: 12px 10px;
      max-height: 65px;
      overflow-x: hidden;
      padding: 3px;
    }

    .std12plot {
      display: none;
    }

    .scatterplot-legend-item {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      margin: 0 10px;
      height: 23px;
      padding: 0 6px !important;
      cursor: pointer;
      overflow: hidden;
      width: 8em;
      word-break: break-all;

    }

    .scatterplot-legend-item.filtered {
      opacity: .3;
    }

    .scatterplot-legend-item.filtered:hover {
      opacity: 1
    }

    .scatterplot-legend-item svg {
      margin-right: 5px;
    }

    .scatterplot-legend-item a {
      width: 9em;
      word-break: unset;
      overflow-x: hidden;
      white-space: nowrap;
      text-align: left;
    }

    #scatterplot-legend-driver .scatterplot-legend-item {
      width: 11em;
    }

    #scatterplot-legend-driver .scatterplot-legend-item span.stationname {
      width: 9.2em;
    }

    .scatterplot-legend .lightfield-button {
      height: unset;
      text-align: center;
      width: unset;
    }

  #hover-description {
     margin: 20px 0;
    font-weight: 600;
  }

</style>
